export const sectorValidation = {
  mandatory,
 }

function mandatory(sector) {
  const errors = {}
  if (!sector.name) {
    errors.name = 'Sector Name is required'
  }
  if (!sector.year) {
    errors.year = 'Year is required'
  }
  if (!sector.sequence) {
    errors.sequence = 'Sequence is required'
  }
  else if (isNaN(sector.sequence)) {
    errors.sequence = 'Sequence should be in number'
  }
      return errors
}
